import { render } from "./NewProduct.vue?vue&type=template&id=04c30cd7&scoped=true"
import script from "./NewProduct.vue?vue&type=script&lang=js"
export * from "./NewProduct.vue?vue&type=script&lang=js"

import "./NewProduct.vue?vue&type=style&index=0&id=04c30cd7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c30cd7"]])

export default __exports__